var styles = {"textCenter":"nv-tabs-text-content--text-center","textLeft":"nv-tabs-text-content--text-left","textRight":"nv-tabs-text-content--text-right","heading":"nv-tabs-text-content--heading","subheading":"nv-tabs-text-content--subheading","tabTextContent":"nv-tabs-text-content--tab-text-content"};

export { styles as default };
//# sourceMappingURL=NvTabsTextContent.module.esm.js.map
